export enum RoleRequestStatus
{
    PENDIENT = 1,
    APPROVE,
    DECLINE
}